import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Grid } from '@mui/joy';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import './UpdatePaymentStatusStyle.css';
import CustomTextArea from '../../../../Components/custom_components/CustomTextArea/CustomTextArea';
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import { TbFileDescription } from 'react-icons/tb';
import { FaHashtag } from 'react-icons/fa';

const paidStatusOptions = [
    { label: 'Paid', value: 'Paid' },
    { label: 'Unpaid', value: 'Unpaid' },
];

function UpdatePaymentStatusForm({ handleSave, isButtonDisabled, initialValues, id, isDisabled }) {
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object({
            paymentStatus: Yup.string().required('Status is required'),
            description: Yup.string().required('Description is required'),
        }),
        enableReinitialize: true,
        onSubmit: (values) => {
            handleSave(values, id);
        },
    });

    const handleReset = () => {
        formik.setValues({
            paymentStatus: '',
            description: '',
        });
        formik.setTouched({
            paymentStatus: false,
            description: false,
        });
    };

    return (
        <div className='update-status-form-container'>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <div className='update-status-form-mid-container'>
                        <div className='update-status-label-container'>
                            <span className='update-status-label'>
                                Payment Status <span className='update-status-required-remark'>*</span>
                            </span>
                        </div>
                        <div className='update-status-custom-textfield-container'>
                            <CustomSelectDropdown
                                name="paymentStatus"
                                placeholder="Select Paid/Unpaid"
                                options={paidStatusOptions}
                                value={paidStatusOptions.find(opt => opt.value === formik.values.paymentStatus)}
                                onChange={(selected) => {
                                    formik.setFieldValue("paymentStatus", selected ? selected.value : '');
                                }}
                                onBlur={formik.handleBlur}
                                error={formik.touched.paymentStatus && Boolean(formik.errors.paymentStatus)}
                                helperText={formik.touched.paymentStatus && formik.errors.paymentStatus}
                                StartIcon={<FaHashtag />}
                                isDisabled={isDisabled}
                                isMulti={false}
                                width="100%"
                            />
                        </div>
                    </div>


                </Grid>
                <Grid item xs={12} md={6}>
                    <div className='update-status-form-mid-container'>
                        <div className='update-status-label-container'>
                            <span className='update-status-label'>
                                Description <span className='update-status-required-remark'>*</span>
                            </span>
                        </div>
                        <div className='update-status-custom-textfield-container'>
                            <CustomTextArea
                                id="description"
                                name="description"
                                placeholder="Enter description"
                                value={formik.values.description}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                rows={5}
                                error={formik.touched.description && Boolean(formik.errors.description)}
                                helperText={formik.touched.description && formik.errors.description}
                                isDisabled={isDisabled}
                            />
                        </div>
                    </div>
                </Grid>
            </Grid>

            {!isDisabled && (
                <div className='update-status-form-bottom-action-buttons-container'>
                    <ActionButton onClick={handleReset} label='Reset' btnType='outlined' />
                    <ActionButton onClick={formik.handleSubmit} btnDisable={isButtonDisabled} label='Save' btnType='primary' />
                </div>
            )}
        </div>
    );
}

export default UpdatePaymentStatusForm;
